import React, { useEffect } from 'react'

interface AboutModalProps {
	isOpen: boolean;
	onClose: () => void;
}

export const AboutModal: React.FC<AboutModalProps> = ({ isOpen, onClose }) => {
	if (!isOpen) return null

	useEffect(() => {
		const keyHandler = (e: KeyboardEvent) => {
			if (e.key === 'Escape') {
				onClose()
			}
		}

		document.addEventListener('keydown', keyHandler)

		return () => document.removeEventListener('keydown', keyHandler)
	}, [])

	return (
		<div className="modal-overlay" onClick={onClose}>
			<div className="help-modal" onClick={(e) => e.stopPropagation()}>
				<div className="help-header">
					<h2>About Memtastic</h2>
					<button className="close-button" onClick={onClose}>×</button>
				</div>

				<div className="help-content">
					<div className="help-section">
						{/* <h3>🎵 Getting Started</h3> */}
						<p>
							Memtastic was created over a weekend by Brian Mortenson, and refined
							since so that it can be (hopefully) user-friendly and easy to figure out for anyone who would like to use it.
						</p>

						<p>
							It's freely available for anyone to use. If you have a question or suggestion, {/* or would like to send a donation to support
							its continued improvement */} please reach out to brian<span></span>@<span></span>mortensoncreative.com. Happy teaching!
						</p>
					</div>
				</div>
			</div>
		</div>
	)
}
